export const ANDROID_PACKAGE = "se.bilenia.app";
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;
export const IOS_STORE_URL =
  import.meta.env.VITE_IOS_STORE_URL ||
  "https://apps.apple.com/app/bilenia/id6786783879";

function isAndroid(): boolean {
  return /android/i.test(navigator.userAgent);
}

function isIOS(): boolean {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

/** Intent URLs only work in Android Chrome/WebView — not desktop devtools or localhost. */
function shouldUseAndroidIntent(appUrl: string): boolean {
  if (!isAndroid()) return false;
  if (import.meta.env.DEV) return false;
  try {
    const host = new URL(appUrl).hostname.toLowerCase();
    if (host === "localhost" || host.endsWith(".local")) return false;
  } catch {
    return false;
  }
  return true;
}

/**
 * Try to open the native app via App Link / Intent; fall back to store if missing.
 */
export function openListingInNativeApp(appUrl: string): void {
  if (shouldUseAndroidIntent(appUrl)) {
    try {
      const parsed = new URL(appUrl);
      const path = `${parsed.host}${parsed.pathname}${parsed.search}`;
      const fallback = encodeURIComponent(PLAY_STORE_URL);
      window.location.href = `intent://${path}#Intent;scheme=https;package=${ANDROID_PACKAGE};S.browser_fallback_url=${fallback};end`;
      return;
    } catch {
      window.location.href = PLAY_STORE_URL;
      return;
    }
  }

  const openedAt = Date.now();
  window.location.href = appUrl;

  if (isIOS()) {
    window.setTimeout(() => {
      if (
        document.visibilityState === "visible" &&
        Date.now() - openedAt < 2500
      ) {
        window.location.href = IOS_STORE_URL;
      }
    }, 1200);
  }
}
